import Typography from '@mui/material/Typography';
import { MIN_AGE, MAX_AGE } from '../constants';
import { PolicyStreamContactBroker } from './PolicyStreamContactBroker';

export const PolicyStreamInvalidAge = () => {
  return (
    <Typography>
      Thank you for your interest in applying for life insurance. At this time,
      it appears that you do not meet the age requirements to qualify for
      coverage, either because you are currently too young (less than {MIN_AGE})
      or beyond the eligible age range (older than {MAX_AGE}). However, we
      encourage you to reach out to your insurance agent directly{' '}
      <PolicyStreamContactBroker /> to discuss your situation. They can provide
      more details and explore any alternative options that may be available to
      you.
    </Typography>
  );
};
